<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :search="search" v-if="!addUser" :headers="headers" :items="eventos" sort-desc class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">EVENTOS</v-toolbar-title>
          <v-spacer></v-spacer>
          
          <!-- Seletor de Empresa -->
          <v-autocomplete
            v-if="user.tipo == 'ADMIN'"
            v-model="empresaSelecionada"
            :items="empresas"
            item-text="nome"
            item-value="id"
            label="Selecione uma Empresa"
            outlined
            dense
            hide-details
            class="mr-4"
            style="max-width: 300px;"
            @change="carregaDados"
          ></v-autocomplete>
          
          <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <!-- <form ref="myform" action="confirmarPagamento" method="POST"></form> -->
          <v-btn text v-if="user.tipo == 'ADMIN'" @click="addNewEvento" tile color="#4A148C">
            <v-icon left dark>add_circle</v-icon> Adicionar novo
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon @click="editItem(item)">edit</v-icon>
        <v-icon medium @click="deleteItem(item)" v-if="companyobj.agenda || companyobj.vigilante">delete</v-icon>
      </template>
      <template v-slot:[`item.inicio`]="{ item }">
        {{ formatarDataTabela(item.inicio) }}
      </template>
      <template v-slot:[`item.fim`]="{ item }">
        {{ formatarDataTabela(item.fim) }}
      </template>
      <template v-slot:no-data>
        <v-btn color="#7B1FA2" @click="carregaDados">Recarregar</v-btn>
      </template>
    </v-data-table>

    <!-- CARD INSERE USUARIOS -->
    <v-card v-else style="border-radius: 10px;">
      <template>
        <v-card-title>
          <span class="textoUser">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:15px; color:#7B1FA2"> *O preenchimento de todos os campos é obrigatório</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="6" md="6">
                <v-textarea v-model="editedItem.descricao" outlined label="Descrição" color="#7B1FA2" persistent-hint counter rows="2" hide-details></v-textarea>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.vagas" outlined label="Vagas" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.reserva" outlined label="Reservas" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.inicio" placeholder="01/01/2020 00:00:00" v-mask="'##/##/#### ##:##:##'" outlined label="Início" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.fim" placeholder="01/01/2020 00:00:00" v-mask="'##/##/#### ##:##:##'" outlined label="Fim" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" v-if="!companyobj.vigilante">
                <v-text-field v-model="editedItem.urlLive" outlined label="URL da Live" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" v-if="!companyobj.vigilante">
                <v-text-field v-model="editedItem.urlPaginaTransmissao" outlined label="URL da Página de Transmissão" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" v-if="!companyobj.vigilante">
                <v-switch
                  v-model="editedItem.transmissaoAtiva"
                  inset
                  color="#7B1FA2"
                  label="Transmissão Ativa"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-select v-model="editedItem.exigePagamento" outlined label="Exige Pagamento" color="#7B1FA2" :items="exigePagamento" hide-details item-text="text" item-value="value"></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-select v-model="editedItem.permiteUpgrade" outlined label="Permite Upgrade" color="#7B1FA2" :items="exigePagamento" hide-details item-text="text" item-value="value"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field v-model="editedItem.vendaMinima" outlined label="Venda Mínima" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field v-model="editedItem.vendaMaxima" outlined label="Venda Máxima" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.subtitulo" outlined label="Subtítulo" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-select v-model="editedItem.tipoDocumento" outlined label="Tipo de Documento" color="#7B1FA2" :items="['AMBOS', 'CPF', 'CNPJ']"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-select v-model="editedItem.documentoPadrao" outlined label="Documento Padrão" color="#7B1FA2" :items="['CPF', 'CNPJ']"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field v-model="editedItem.vagasMasculinas" outlined label="Vagas Masculinas" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field v-model="editedItem.vagasFemininas" outlined label="Vagas Femininas" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" v-if="user.tipo == 'ADMIN'">
                <v-switch
                  v-model="editedItem.ativo"
                  inset
                  color="#7B1FA2"
                  label="Evento Ativo"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlCapa" outlined label="URL da Capa" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlMapa" outlined label="URL do Mapa" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlImgObs" outlined label="URL Imagem Observações" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlImgConfirmacaoPagamento" outlined label="URL Imagem Confirmação Pagamento" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlCertificado" outlined label="URL do Certificado" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.urlTabelaHorarios" outlined label="URL Tabela de Horários" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.local" outlined label="Local" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.localizacao" outlined label="Localização (URL do Maps)" color="#7B1FA2"></v-text-field>
              </v-col>
              
              <v-col cols="12" sm="12">
                <v-divider></v-divider>
                <h3 class="mt-4 mb-2">Configurações de Pagamento</h3>
              </v-col>
              
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.valor" outlined label="Valor" color="#7B1FA2" prefix="R$"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.valorPix" outlined label="Valor Pix" color="#7B1FA2" prefix="R$"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.valorCartao" outlined label="Valor Cartão" color="#7B1FA2" prefix="R$"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.desconto" outlined label="Desconto" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.lote" outlined label="Lote" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.quantidadeParcelas" outlined label="Quantidade de Parcelas" color="#7B1FA2" type="number"></v-text-field>
              </v-col>
              
              <v-col cols="12" sm="12">
                <v-divider></v-divider>
                <h3 class="mt-4 mb-2">Acréscimos de Pagamento</h3>
              </v-col>
              
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao1" outlined label="Acréscimo Cartão 1x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao2" outlined label="Acréscimo Cartão 2x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao3" outlined label="Acréscimo Cartão 3x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao4" outlined label="Acréscimo Cartão 4x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao5" outlined label="Acréscimo Cartão 5x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao6" outlined label="Acréscimo Cartão 6x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao7" outlined label="Acréscimo Cartão 7x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao8" outlined label="Acréscimo Cartão 8x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao9" outlined label="Acréscimo Cartão 9x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao10" outlined label="Acréscimo Cartão 10x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao11" outlined label="Acréscimo Cartão 11x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoCartao12" outlined label="Acréscimo Cartão 12x" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoBoleto" outlined label="Acréscimo Boleto" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="editedItem.acrescimoPix" outlined label="Acréscimo Pix" color="#7B1FA2"></v-text-field>
              </v-col>
              
              <v-col cols="12" sm="12" v-if="!companyobj.vigilante && user.tipo == 'ADMIN'">
                <v-divider></v-divider>
                <h3 class="mt-4 mb-2">Configurações de Cabeçalho</h3>
              </v-col>
              
              <v-col cols="12" sm="12" md="12" v-if="!companyobj.vigilante && user.tipo == 'ADMIN'">
                <v-btn color="#4A148C" class="mb-4" @click="abrirEditorCabecalho">
                  <v-icon left>edit</v-icon>
                  Editar Colunas do Cabeçalho
                </v-btn>
                
                <v-card v-if="mostrarEditorCabecalho" outlined class="pa-4 mb-4">
                  <v-card-title>Editor de Cabeçalho</v-card-title>
                  <v-card-text>
                    <v-row v-for="(coluna, index) in editedItem.cabecalho" :key="index">
                      <v-col cols="12" sm="5" md="5">
                        <v-text-field v-model="coluna.text" outlined label="Título da Coluna" color="#7B1FA2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="5" md="5">
                        <v-text-field v-model="coluna.value" outlined label="Campo de Referência" color="#7B1FA2"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-btn icon color="red" @click="removerColuna(index)">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-btn color="#7B1FA2" class="mt-4" dark @click="adicionarColuna">
                      <v-icon left>add</v-icon>
                      Adicionar Coluna
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
              
              <v-col cols="12" sm="12" md="12" v-if="companyobj.vigilante">
                <v-select v-model="editedItem.qualificacoes" outlined label="Qualificações Permitidas" color="#7B1FA2" :items="qualificacoes" hide-details item-text="text" item-value="value" multiple></v-select>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.vlApoio" prefix="R$" outlined label="Diária Apoio" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.vlBasico" prefix="R$" outlined label="Diária Básico" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.vlGrandesEventos" prefix="R$" outlined label="Diária Grandes Eventos" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.hrInicio" outlined label="Hora Início" v-mask="'##:##'" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.hrApresentacao" outlined label="Hora Apresentação" v-mask="'##:##'" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.hrFim" outlined label="Hota Término" v-mask="'##:##'" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" v-if="companyobj.vigilante">
                <v-text-field v-model="editedItem.endereco" outlined label="Endereço/Localização" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                  <p>Traje</p>
                  <v-radio-group
                    v-model="editedItem.traje"
                    mandatory
                  >
                    <v-radio
                      label="SOCIAL"
                      value="SOCIAL"
                    ></v-radio>
                    <v-radio
                      label="OPERACIONAL"
                      value="OPERACIONAL"
                    ></v-radio>
                  </v-radio-group>
              </v-col>  
              <v-col cols="4" sm="4" md="4" v-if="companyobj.vigilante">
                  <p>Incluso Alimentação</p>
                  <v-radio-group
                    v-model="editedItem.alimentacao"
                    mandatory
                  >
                    <v-radio
                      label="SIM"
                      value="SIM"
                    ></v-radio>
                    <v-radio
                      label="NÃO"
                      value="NÃO"
                    ></v-radio>
                  </v-radio-group>
              </v-col>

              <!-- Seção de Planos -->
              <v-col cols="12" sm="12">
                <v-divider></v-divider>
                <div class="d-flex align-center mt-4 mb-2">
                  <h3>Planos de Pagamento</h3>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#4A148C"
                    dark
                    small
                    @click="adicionarPlano"
                  >
                    <v-icon left>add</v-icon>
                    Adicionar Plano
                  </v-btn>
                </div>
                <p class="text-caption mb-3">Configure os planos de pagamento disponíveis para este evento</p>
              </v-col>

              <!-- Lista de Planos -->
              <v-col cols="12" v-if="editedItem.planos && editedItem.planos.length > 0">
                <v-card 
                  v-for="(plano, index) in editedItem.planos" 
                  :key="index"
                  outlined
                  class="mb-3"
                >
                  <v-card-title class="py-2">
                    <span class="text-h6">{{ plano.plano || `Plano ${index + 1}` }}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      color="red"
                      @click="removerPlano(index)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="plano.plano"
                          outlined
                          label="Nome do Plano"
                          color="#7B1FA2"
                          placeholder="Ex: Plano A"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="plano.detalhes"
                          outlined
                          label="Detalhes"
                          color="#7B1FA2"
                          placeholder="Ex: Janeiro a Maio"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="plano.valorPix"
                          outlined
                          label="Valor Pix"
                          color="#7B1FA2"
                          prefix="R$"
                          placeholder="800,00"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="plano.valorCartao"
                          outlined
                          label="Valor Cartão"
                          color="#7B1FA2"
                          prefix="R$"
                          placeholder="800,00"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="plano.acrescimoPix"
                          outlined
                          label="Acréscimo Pix"
                          color="#7B1FA2"
                          placeholder="0,00"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="plano.quantidadeParcelas"
                          outlined
                          label="Qtd Parcelas"
                          color="#7B1FA2"
                          type="number"
                          min="1"
                          max="12"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    
                    <!-- Acréscimos por parcela -->
                    <v-row v-if="plano.quantidadeParcelas && plano.quantidadeParcelas > 1">
                      <v-col cols="12">
                        <v-subheader class="pl-0">Acréscimos por Parcela</v-subheader>
                      </v-col>
                      <v-col 
                        cols="6" 
                        md="3" 
                        v-for="i in parseInt(plano.quantidadeParcelas)" 
                        :key="`parcela-${i}`"
                      >
                        <v-text-field
                          v-model="plano[`acrescimoCartao${i}`]"
                          outlined
                          :label="`Acréscimo ${i}x`"
                          color="#7B1FA2"
                          placeholder="0,00"
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Mensagem quando não há planos -->
              <v-col cols="12" v-else>
                <v-alert
                  type="info"
                  outlined
                  class="mb-0"
                >
                  Nenhum plano de pagamento configurado. Clique em "Adicionar Plano" para começar.
                </v-alert>
              </v-col>

              <!-- Seção do Cronômetro -->
              <v-col cols="12" sm="12">
                <v-divider></v-divider>
                <div class="d-flex align-center mt-4 mb-2">
                  <h3>Programação do Cronômetro</h3>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#4A148C"
                    dark
                    small
                    @click="adicionarCronometro"
                  >
                    <v-icon left>add</v-icon>
                    Adicionar Item
                  </v-btn>
                </div>
                <p class="text-caption mb-3">Configure a programação automática do cronômetro regressivo</p>
              </v-col>

              <!-- Lista de Cronômetros -->
              <v-col cols="12" v-if="editedItem.cronometro && editedItem.cronometro.length > 0">
                <v-card 
                  v-for="(item, index) in editedItem.cronometro" 
                  :key="index"
                  outlined
                  class="mb-3"
                >
                  <v-card-title class="py-2">
                    <span class="text-h6">Item {{ index + 1 }}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      color="red"
                      @click="removerCronometro(index)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="item.descricao"
                          outlined
                          label="Descrição"
                          color="#7B1FA2"
                          placeholder="Ex: PALESTRANTE 1"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="item.tempoEmMinutos"
                          outlined
                          label="Tempo (minutos)"
                          color="#7B1FA2"
                          type="number"
                          min="1"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="item.cor"
                          outlined
                          label="Cor"
                          color="#7B1FA2"
                          placeholder="#0800ff"
                        >
                          <template v-slot:append>
                            <input
                              type="color"
                              v-model="item.cor"
                              style="width: 30px; height: 30px; border: none; cursor: pointer;"
                            />
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="item.dataHoraInicio"
                          placeholder="01/01/2025 18:15:00"
                          v-mask="'##/##/#### ##:##:##'"
                          outlined
                          label="Data e Hora de Início"
                          color="#7B1FA2"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Mensagem quando não há cronômetros -->
              <v-col cols="12" v-else>
                <v-alert
                  type="info"
                  outlined
                  class="mb-0"
                >
                  Nenhum item de cronômetro configurado. Clique em "Adicionar Item" para começar.
                </v-alert>
              </v-col>             
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A148C" class="cssBotao" dark large @click="save">Salvar</v-btn>
          <v-btn color="#BA68C8" max-width="" class="cssBotao" large dark @click="close">Cancelar</v-btn>
        </v-card-actions>
      </template>
    </v-card>

    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      limitado: true,
      faixas: [],
      search: '',
      addUser: false,
      mostrarEditorCabecalho: false,
      exigePagamento: [
        { text: 'SIM', value: true, },
        { text: 'NÃO', value: false, },
      ],
      headers: [
        { text: 'Nome', align: 'start', value: 'nome', },
        { text: 'Vagas', align: 'center', value: 'vagas' },
        { text: 'Data Início', value: 'inicio' },
        { text: 'Data Fim', value: 'fim' },
        { text: 'Ações', value: 'action', align: 'center', sortable: false },
      ],
      qualificacoes: ['APOIO', 'VIGILANTE BÁSICO', 'VIGILANTE DE GRANDES EVENTOS'],
      eventos: [],
      editedIndex: -1,
      editedItem: {
        nome: '',
        descricao: '',
        vagas: '',
        reserva: '',
        inicio: '',
        fim: '',
        ativo: true,
        empresaId: '',
        urlLive: '',
        urlPaginaTransmissao: '',
        transmissaoAtiva: false,
        qualificacoes: [],
        vlApoio: '',
        vlBasico: '',
        vlGrandesEventos: '',
        hrInicio: '',
        hrApresentacao: '',
        hrFim: '',
        endereco: '',
        traje: '',
        alimentacao: '',
        exigePagamento: false,
        permiteUpgrade: false,
        vendaMinima: 1,
        vendaMaxima: 50,
        tipoDocumento: 'AMBOS',
        documentoPadrao: 'CPF',
        urlCapa: '',
        urlMapa: '',
        urlImgObs: '',
        urlImgConfirmacaoPagamento: '',
        vagasMasculinas: 0,
        vagasFemininas: 0,
        urlCertificado: '',
        cabecalho: [],
        quantidadeInscricoes: 0,
        local: '',
        localizacao: '',
        setores: [],
        subtitulo: '',
        acrescimoCartao1: '0,00',
        acrescimoCartao2: '0,00',
        acrescimoCartao3: '0,00',
        acrescimoCartao4: '0,00',
        acrescimoCartao5: '0,00',
        acrescimoCartao6: '0,00',
        acrescimoCartao7: '0,00',
        acrescimoCartao8: '0,00',
        acrescimoCartao9: '0,00',
        acrescimoCartao10: '0,00',
        acrescimoCartao11: '0,00',
        acrescimoCartao12: '0,00',
        acrescimoBoleto: '0,00',
        acrescimoPix: '0,00',
        lote: 1,
        valor: '',
        valorPix: '',
        valorCartao: '',
        desconto: '',
        quantidadeParcelas: 1,
        usaCupomDesconto: false,
        usaCartaoConsumo: false,
        usaLinkDesconto: false,
        exibePorcentagem: false,
        permiteSenhaExtra: false,
        valorSenhaExtra: '',
        parametroContagem: {
          tipo: 'numero',
          parametro: 'qtdSenhasExtra'
        },
        qtdClicks: 0,
        sebraeCodigoEvento: '',
        turmas: [],
        planos: [],
        ordenacao: 0,
        urlTabelaHorarios: '',
        exigeUniforme: false,
        cronometro: []
      },
      defaultItem: {
        nome: '',
        descricao: '',
        vagas: '',
        reserva: '',
        inicio: '',
        fim: '',
        ativo: true,
        empresaId: '',
        urlLive: '',  
        urlPaginaTransmissao: '',
        transmissaoAtiva: false,
        qualificacoes: [],
        vlApoio: '',
        vlBasico: '',
        vlGrandesEventos: '',
        hrInicio: '',
        hrApresentacao: '',
        hrFim: '',
        endereco: '',
        traje: '',
        alimentacao: '',
        exigePagamento: false,
        permiteUpgrade: false,
        vendaMinima: 1,
        vendaMaxima: 50,
        tipoDocumento: 'AMBOS',
        documentoPadrao: 'CPF',
        urlCapa: '',
        urlMapa: '',
        urlImgObs: '',
        urlImgConfirmacaoPagamento: '',
        vagasMasculinas: 0,
        vagasFemininas: 0,
        urlCertificado: '',
        cabecalho: [],
        quantidadeInscricoes: 0,
        local: '',
        localizacao: '',
        setores: [],
        subtitulo: '',
        acrescimoCartao1: '0,00',
        acrescimoCartao2: '0,00',
        acrescimoCartao3: '0,00',
        acrescimoCartao4: '0,00',
        acrescimoCartao5: '0,00',
        acrescimoCartao6: '0,00',
        acrescimoCartao7: '0,00',
        acrescimoCartao8: '0,00',
        acrescimoCartao9: '0,00',
        acrescimoCartao10: '0,00',
        acrescimoCartao11: '0,00',
        acrescimoCartao12: '0,00',
        acrescimoBoleto: '0,00',
        acrescimoPix: '0,00',
        lote: 1,
        valor: '',
        valorPix: '',
        valorCartao: '',
        desconto: '',
        quantidadeParcelas: 1,
        usaCupomDesconto: false,
        usaCartaoConsumo: false,
        usaLinkDesconto: false,
        exibePorcentagem: false,
        permiteSenhaExtra: false,
        valorSenhaExtra: '',
        parametroContagem: {
          tipo: 'numero',
          parametro: 'qtdSenhasExtra'
        },
        qtdClicks: 0,
        sebraeCodigoEvento: '',
        turmas: [],
        planos: [],
        ordenacao: 0,
        urlTabelaHorarios: '',
        exigeUniforme: false,
        cronometro: []
      },
      empresas: [],
      empresaSelecionada: null,
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR NOVO EVENTO ' : 'EDITAR EVENTO'
      }
    }),

    created() {
      if (this.user.tipo === 'ADMIN') {
        this.carregaEmpresas()
      }
    },

    mounted() {
      this.carregaDados()
    },

    methods: {
      async addNewEvento() {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.addUser = true
        await this.verificaDisponibilidade()
      },

      async carregaEmpresas() {
        this.isLoading = true
        try {
          const res = await axios.get(`${baseApiUrl}Empresas?access_token=${sessionStorage.getItem('accToken')}`)
          if (res.data && res.data.length > 0) {
            this.empresas = res.data
          }
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar empresas", "ERRO")
        }
      },

      async carregaDados() {
        this.isLoading = true
        
        // URL base para a consulta
        let url
        
        // Filtra por empresa ou traz todos os eventos dependendo do tipo de usuário
        if (this.user.tipo === 'ADMIN') {
          if (this.empresaSelecionada) {
            url = `${baseApiUrl}eventos?filter={"where":{"empresaId":"${this.empresaSelecionada}"}, "order":"inicio DESC"}&access_token=${sessionStorage.getItem('accToken')}`
          } else {
            url = `${baseApiUrl}eventos?access_token=${sessionStorage.getItem('accToken')}`
          }
        } else {
          url = `${baseApiUrl}eventos?filter={"where":{"empresaId":"${this.companyobj.id}"}, "order":"inicio DESC"}&access_token=${sessionStorage.getItem('accToken')}`
        }
        
        await axios.get(url)
        .then(res => {
          if (res.data != '') {
            this.eventos = res.data
            this.isLoading = false
          } else {
            this.eventos = []
            this.isLoading = false
          }
        })
        .catch(() => {
          this.isLoading = false
          this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar eventos", "ERRO")
        })
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()
        let comparison = 0;
        if (dataC >= dataA) {
          comparison = 1;
        } else if (dataC < dataA) {
          comparison = -1;
        }
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      editItem(item) {
        this.editedIndex = this.eventos.indexOf(item)
        
        // Criar uma cópia do item para não modificar o original
        const itemCopy = Object.assign({}, item)
        
        // Converter as datas do formato ISO para o formato exibido ao usuário
        if (itemCopy.inicio) {
          try {
            const dataInicio = new Date(itemCopy.inicio)
            if (!isNaN(dataInicio.getTime())) {
              const dia = String(dataInicio.getDate()).padStart(2, '0')
              const mes = String(dataInicio.getMonth() + 1).padStart(2, '0')
              const ano = dataInicio.getFullYear()
              const horas = String(dataInicio.getHours()).padStart(2, '0')
              const minutos = String(dataInicio.getMinutes()).padStart(2, '0')
              const segundos = String(dataInicio.getSeconds()).padStart(2, '0')
              
              itemCopy.inicio = `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`
            }
          } catch (e) {
            // Manter valor original se houver erro na conversão
          }
        }
        
        if (itemCopy.fim) {
          try {
            const dataFim = new Date(itemCopy.fim)
            if (!isNaN(dataFim.getTime())) {
              const dia = String(dataFim.getDate()).padStart(2, '0')
              const mes = String(dataFim.getMonth() + 1).padStart(2, '0')
              const ano = dataFim.getFullYear()
              const horas = String(dataFim.getHours()).padStart(2, '0')
              const minutos = String(dataFim.getMinutes()).padStart(2, '0')
              const segundos = String(dataFim.getSeconds()).padStart(2, '0')
              
              itemCopy.fim = `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`
            }
          } catch (e) {
            // Manter valor original se houver erro na conversão
          }
        }
        
        // Formatar cronômetro para exibição no formulário
        if (itemCopy.cronometro && Array.isArray(itemCopy.cronometro)) {
          itemCopy.cronometro = itemCopy.cronometro.map(cronItem => {
            let dataHoraInicio = cronItem.dataHoraInicio;
            
            // Converter data ISO para formato DD/MM/AAAA HH:MM:SS
            if (dataHoraInicio) {
              try {
                const data = new Date(dataHoraInicio);
                if (!isNaN(data.getTime())) {
                  const dia = String(data.getDate()).padStart(2, '0');
                  const mes = String(data.getMonth() + 1).padStart(2, '0');
                  const ano = data.getFullYear();
                  const horas = String(data.getHours()).padStart(2, '0');
                  const minutos = String(data.getMinutes()).padStart(2, '0');
                  const segundos = String(data.getSeconds()).padStart(2, '0');
                  
                  dataHoraInicio = `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
                }
              } catch (e) {
                // Manter valor original se houver erro
              }
            }
            
            return {
              ...cronItem,
              dataHoraInicio: dataHoraInicio
            };
          });
        } else {
          itemCopy.cronometro = [];
        }
        
        this.editedItem = itemCopy
        this.addUser = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir o Evento: ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(`${baseApiUrl}Eventos/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaDados()
          })
        }
      },

      close() {
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save() {
        this.isLoading = true
        try {
          // Validação das datas
          if (!this.editedItem.inicio || !this.editedItem.fim) {
            throw new Error("As datas de início e fim são obrigatórias");
          }
          
          // Validação do cronômetro
          if (!this.validarCronometro()) {
            this.isLoading = false;
            return;
          }
          
          // Validação dos planos
          if (!this.validarPlanos()) {
            this.isLoading = false;
            return;
          }
          
          // Criar cópias dos valores para não alterar o formulário
          const itemToSave = { ...this.editedItem };
          
          // Converter valores numéricos
          itemToSave.vagas = parseInt(itemToSave.vagas) || 0;
          itemToSave.reserva = parseInt(itemToSave.reserva) || 0;
          
          // Formatação de datas
          try {
            // Para início            
            if (typeof itemToSave.inicio === 'string') {
              // Verificar se está no formato DD/MM/AAAA HH:MM:SS
              if (itemToSave.inicio.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                const [data, hora] = itemToSave.inicio.split(' ');
                const [dia, mes, ano] = data.split('/');
                
                try {
                  // Criar um objeto Date válido
                  const dataStr = `${ano}-${mes}-${dia}T${hora}`;
                  const dataObj = new Date(dataStr);
                  
                  // Verificar se é uma data válida
                  if (isNaN(dataObj.getTime())) {
                    throw new Error("Data de início inválida");
                  }
                  
                  // Formatando para o padrão ISO que a API espera
                  itemToSave.inicio = dataObj.toISOString();
                } catch (e) {
                  throw new Error(`Erro ao converter data de início: ${e.message}`);
                }
              } else if (!itemToSave.inicio.includes('T')) {
                throw new Error("Formato de data de início inválido. Use o formato DD/MM/AAAA HH:MM:SS");
              }
            } else {
              throw new Error("Data de início deve ser uma string");
            }
            
            // Para fim            
            if (typeof itemToSave.fim === 'string') {
              // Verificar se está no formato DD/MM/AAAA HH:MM:SS
              if (itemToSave.fim.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                const [data, hora] = itemToSave.fim.split(' ');
                const [dia, mes, ano] = data.split('/');
                
                try {
                  // Criar um objeto Date válido
                  const dataStr = `${ano}-${mes}-${dia}T${hora}`;
                  const dataObj = new Date(dataStr);
                  
                  // Verificar se é uma data válida
                  if (isNaN(dataObj.getTime())) {
                    throw new Error("Data de fim inválida");
                  }
                  
                  // Formatando para o padrão ISO que a API espera
                  itemToSave.fim = dataObj.toISOString();
                } catch (e) {
                  // Erro na conversão da data de fim
                }
              } else if (!itemToSave.fim.includes('T')) {
                throw new Error("Formato de data de fim inválido. Use o formato DD/MM/AAAA HH:MM:SS");
              }
            } else {
              throw new Error("Data de fim deve ser uma string");
            }
            
          } catch (dateError) {
            this.isLoading = false;
            this.$refs.chamaSnackbar.snack("#EF5350", `Erro no formato de data: ${dateError.message}`, "ERRO");
            return;
          }
          
          // Formatar cronômetro para API
          itemToSave.cronometro = this.formatarCronometroParaAPI();
          
          if (this.editedIndex != -1) {
            // Atualizando evento existente
            await axios.patch(`${baseApiUrl}Eventos/${itemToSave.id}?access_token=${sessionStorage.getItem('accToken')}`, itemToSave)
              .then(res => {
                if (res.data != null) {
                  this.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO");
                  this.carregaDados();
                }
              }).catch(error => {
                this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação: " + (error.response && error.response.data ? JSON.stringify(error.response.data) : error.message), "ERRO");
              });
          } else {
            // Criando novo evento
            itemToSave.empresaId = this.companyobj.id;
            
            await axios.post(`${baseApiUrl}Eventos/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, itemToSave)
              .then(res => {
                if (res.data != null) {
                  this.id_evento = res.data.id;
                  this.$refs.chamaSnackbar.snack("#0288D1", "Evento cadastrado com sucesso!", "INFORMAÇÃO");
                  this.carregaDados();
                }
              }).catch(error => {
                this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar evento: " + (error.response && error.response.data ? JSON.stringify(error.response.data) : error.message), "ERRO");
              });
          }
          this.close();
        } catch (e) {
          this.isLoading = false;
          this.$refs.chamaSnackbar.snack("#EF5350", "Erro: " + e.message, "ERRO");
        } finally {
          this.isLoading = false;
        }
      },

      async verificaDisponibilidade() {
        // ... existing code ...
      },

      abrirEditorCabecalho() {
        this.mostrarEditorCabecalho = !this.mostrarEditorCabecalho;
        
        // Se não houver cabeçalho definido, criar um padrão
        if (!this.editedItem.cabecalho || this.editedItem.cabecalho.length === 0) {
          this.editedItem.cabecalho = [
            { text: "Código", value: "cod_incricao" },
            { text: "Nome", value: "nome" },
            { text: "CPF", value: "cpf" },
            { text: "E-mail", value: "email" },
            { text: "Telefone", value: "telefone" },
            { text: "Valor", value: "valorPago" },
            { text: "Status", value: "statusPagamento" },
            { text: "Realizada em", value: "dataHora" },
            { text: "Checkin", value: "checkin" },
            { text: "Ações", value: "action" }
          ];
        }
      },

      adicionarColuna() {
        if (!this.editedItem.cabecalho) {
          this.editedItem.cabecalho = [];
        }
        this.editedItem.cabecalho.push({ text: '', value: '' });
      },

      removerColuna(index) {
        this.editedItem.cabecalho.splice(index, 1);
      },

      formatarDataTabela(data) {
        if (!data) return null;
        try {
          // Primeiro tenta formatar normalmente
          const dataFormatada = moment(data).format('DD/MM/YYYY HH:mm:ss');
          
          // Verifica se a data é válida
          if (dataFormatada === 'Invalid date') {
            // Se o formato já tiver T, pode ser que seja uma string ISO com problemas
            if (typeof data === 'string' && data.includes('T')) {
              // Tenta limpar a string para remover caracteres problemáticos
              const dataLimpa = data.replace(/[^\d\-T:.Z]/g, '');
              return moment(dataLimpa).format('DD/MM/YYYY HH:mm:ss');
            }
            // Se nada funcionar, retorna a data original
            return data;
          }
          
          return dataFormatada;
        } catch (e) {
          return data; // Retorna o valor original em caso de erro
        }
      },

      // Métodos para gerenciar planos
      adicionarPlano() {
        if (!this.editedItem.planos) {
          this.editedItem.planos = [];
        }
        
        // Adicionar um novo plano com valores padrão
        const novoPlano = {
          plano: `Plano ${String.fromCharCode(65 + this.editedItem.planos.length)}`, // A, B, C, etc.
          detalhes: '',
          valorPix: '0,00',
          valorCartao: '0,00',
          acrescimoPix: '0,00',
          quantidadeParcelas: 1
        };
        
        // Adicionar campos de acréscimo para cada parcela (até 12)
        for (let i = 1; i <= 12; i++) {
          novoPlano[`acrescimoCartao${i}`] = '0,00';
        }
        
        this.editedItem.planos.push(novoPlano);
      },

      removerPlano(index) {
        if (this.editedItem.planos && this.editedItem.planos.length > index) {
          this.editedItem.planos.splice(index, 1);
        }
      },

      validarPlanos() {
        if (!this.editedItem.planos || this.editedItem.planos.length === 0) {
          return true; // Planos são opcionais
        }

        for (let i = 0; i < this.editedItem.planos.length; i++) {
          const plano = this.editedItem.planos[i];
          
          if (!plano.plano || plano.plano.trim() === '') {
            this.$refs.chamaSnackbar.snack("#EF5350", `Plano ${i + 1}: Nome do plano é obrigatório`, "ERRO");
            return false;
          }
          
          if (!plano.valorPix || plano.valorPix.trim() === '') {
            this.$refs.chamaSnackbar.snack("#EF5350", `Plano ${i + 1}: Valor Pix é obrigatório`, "ERRO");
            return false;
          }
          
          if (!plano.valorCartao || plano.valorCartao.trim() === '') {
            this.$refs.chamaSnackbar.snack("#EF5350", `Plano ${i + 1}: Valor Cartão é obrigatório`, "ERRO");
            return false;
          }
          
          if (!plano.quantidadeParcelas || plano.quantidadeParcelas < 1 || plano.quantidadeParcelas > 12) {
            this.$refs.chamaSnackbar.snack("#EF5350", `Plano ${i + 1}: Quantidade de parcelas deve ser entre 1 e 12`, "ERRO");
            return false;
          }
        }
        
        return true;
      },

      // Métodos para gerenciar cronômetro
      adicionarCronometro() {
        if (!this.editedItem.cronometro) {
          this.editedItem.cronometro = [];
        }
        
        // Adicionar um novo item de cronômetro com valores padrão
        this.editedItem.cronometro.push({
          descricao: '',
          tempoEmMinutos: 5,
          cor: '#0800ff',
          dataHoraInicio: ''
        });
      },

      removerCronometro(index) {
        if (this.editedItem.cronometro && this.editedItem.cronometro.length > index) {
          this.editedItem.cronometro.splice(index, 1);
        }
      },

      validarCronometro() {
        if (!this.editedItem.cronometro || this.editedItem.cronometro.length === 0) {
          return true; // Cronômetro é opcional
        }

        for (let i = 0; i < this.editedItem.cronometro.length; i++) {
          const item = this.editedItem.cronometro[i];
          
          if (!item.descricao || item.descricao.trim() === '') {
            this.$refs.chamaSnackbar.snack('error', `Item ${i + 1}: Descrição é obrigatória`);
            return false;
          }
          
          if (!item.tempoEmMinutos || item.tempoEmMinutos <= 0) {
            this.$refs.chamaSnackbar.snack('error', `Item ${i + 1}: Tempo deve ser maior que zero`);
            return false;
          }
          
          if (!item.cor || item.cor.trim() === '') {
            this.$refs.chamaSnackbar.snack('error', `Item ${i + 1}: Cor é obrigatória`);
            return false;
          }
          
          if (!item.dataHoraInicio || item.dataHoraInicio.trim() === '') {
            this.$refs.chamaSnackbar.snack('error', `Item ${i + 1}: Data e hora de início são obrigatórias`);
            return false;
          }
          
          // Validar formato da data
          if (!item.dataHoraInicio.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
            this.$refs.chamaSnackbar.snack('error', `Item ${i + 1}: Formato de data inválido. Use DD/MM/AAAA HH:MM:SS`);
            return false;
          }
        }
        
        return true;
      },

      formatarCronometroParaAPI() {
        if (!this.editedItem.cronometro || this.editedItem.cronometro.length === 0) {
          return [];
        }

        return this.editedItem.cronometro.map(item => {
          // Converter data de DD/MM/AAAA HH:MM:SS para ISO
          let dataHoraInicio = item.dataHoraInicio;
          
          if (dataHoraInicio && dataHoraInicio.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
            const [data, hora] = dataHoraInicio.split(' ');
            const [dia, mes, ano] = data.split('/');
            const dataStr = `${ano}-${mes}-${dia}T${hora}`;
            const dataObj = new Date(dataStr);
            
            if (!isNaN(dataObj.getTime())) {
              dataHoraInicio = dataObj.toISOString();
            }
          }

          return {
            descricao: item.descricao,
            tempoEmMinutos: parseInt(item.tempoEmMinutos),
            cor: item.cor,
            dataHoraInicio: dataHoraInicio
          };
        });
      }
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>